import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-audio-player',
  styleUrls: ['./audio-player.component.scss'],
  templateUrl: './audio-player.component.html'
})
export class AudioPlayerComponent {
  @ViewChild('audio') audio: ElementRef<HTMLAudioElement>;
  @ViewChild('progress') progress: ElementRef;

  @Output() started: EventEmitter<{ id: number }> = new EventEmitter<{ id: number }>();

  public loaded = false;

  // request animation frame
  raf = null;

  // progress trackeléshez
  currentTime = 0;
  currentTimeText = '0:00';
  maxTime = 100;
  maxTimeText = '0:00';

  @Input() src = '';
  @Input() isPlaying = false;
  @Input() audioId;

  // <audio> tag gyakorlatilag, amire tudjuk hívni a böngésző a basic parnacsokat
  get $player(): HTMLAudioElement {
    return this.audio.nativeElement;
  }

  init() {
    // Audio hossz beállítás
    this.maxTimeText = this.calculateTime(this.$player.duration);
    this.maxTime = this.$player.duration;
    this.loaded = true;
  }

  // audio lejátszás indítása
  play() {
    this.isPlaying = true;
    this.$player.play();
    requestAnimationFrame(this.whilePlaying);
    if ( this.audioId ) this.started.emit({id: this.audioId});
  }

  // audio lejátszás megállítása
  stop() {
    this.isPlaying = false;
    this.$player.pause();
    cancelAnimationFrame(this.raf);
  }

  // seek gyakorlatilag az onChange event
  // amikor a user interaktál a sliderrel és elengedi azt
  // Ez az input után hívódik meg szóval itt állítjuk be a ténylegesen
  // a $player currenTime értéke és indítjuk el újra a lejátszást
  seek() {
    this.$player.currentTime = this.currentTime;
    if ( !this.$player.paused ) requestAnimationFrame(this.whilePlaying)
  }

  // input gyakorlatilag az onInput event
  // amikor a user interaktál a sliderrel
  // Itt módosítjuk a kijelzett currentTime-t
  // De a plyert leállítjuk, majd a changbe indítjuk újra azt (gyakorlatilag rögtön ezután)
  input() {
    this.currentTimeText = this.calculateTime(this.currentTime);
    if ( !this.$player.paused ) cancelAnimationFrame(this.raf);
  }

  // másodperc human readable formátumra megjelenítéshez
  calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
  }

  // Framek frissítési callbackje, frissítgetjük amit frissíteni kell
  whilePlaying = () => {
    this.currentTime = Math.floor(this.$player.currentTime);
    this.currentTimeText = this.calculateTime( this.currentTime);
    this.raf = requestAnimationFrame(this.whilePlaying);
  }

}
